// i18n
import { translateInComponent } from 'infras/i18n';
import translations from 'presentations/views/components/pages/SharedEventPage/i18n.json';

import MainDocument from 'presentations/views/components/MainDocument';
import SharedEventPage from 'presentations/views/components/pages/SharedEventPage';
import { GetServerSideProps } from 'next';
import { apiPath, eventOgpImagePath } from 'presentations/routes/path';
import { get, serverSideGet } from 'infras/rest_client';
import { SharedEventDetailItem } from 'presentations/api/schema/event';
import { formatToSeconds } from 'infras/datetime';
import { formatHostName } from 'presentations/views/helpers/formatter';
import { splitHostAndUsersFromEventType } from 'presentations/views/helpers/event_type';
import { SharedEventTypeItem } from 'presentations/api/schema/event_type';
import { PlanId } from 'domains/models/subscription/planId';
import { SourceType } from 'domains/models/event_source/sourceType';

interface ServerProps {
  event: SharedEventDetailItem;
  eventType: SharedEventTypeItem | null;
  hostName: string;
}

export const getServerSideProps: GetServerSideProps = async ({
  req,
  params,
}: any) => {
  let result = await serverSideGet(
    req,
    apiPath(`/v1/events/${params.eventId}`),
  );
  if (!result.isSuccess) {
    return { props: { statusCode: 404 } };
  }
  if (!result.data) {
    return { props: { statusCode: 404 } };
  }
  const event: SharedEventDetailItem = result.data;

  let eventType: SharedEventTypeItem | null = null;
  if (event.sourceType === SourceType.EventType) {
    result = await get(apiPath(`/v1/guests/event_types/${event.eventTypeId}`));
    if (!result.isSuccess || !result.data) {
      return { props: { statusCode: 404 } };
    }
    eventType = result.data;
  }

  const { host } = splitHostAndUsersFromEventType(event.users);
  if (!host) {
    return { props: { statusCode: 403 } };
  }
  const hostName = formatHostName(
    event.hostOperationType,
    host.name,
    event.team?.name || null,
  );
  const props: ServerProps = { event, eventType, hostName };
  return { props };
};

export default function Page(props: ServerProps) {
  const t = translateInComponent(translations);
  const imageUrl = eventOgpImagePath(props.event.uid);
  const title = t('title', {
    eventName: props.event.name,
    hostName: props.hostName,
  });
  return (
    <MainDocument
      title={title}
      isNoIndex={true}
      isExcludeSiteName={
        !!(props.eventType && props.eventType.planId !== PlanId.Free)
      }
      image={imageUrl}
    >
      <SharedEventPage
        mapApiKey={String(process.env['GOOGLE_MAP_API_KEY'])}
        event={props.event}
        planId={props.eventType ? props.eventType.planId : PlanId.Free}
        isShowPromotion={
          props.eventType ? props.eventType.isShowPromotion : true
        }
        isShowHeaderTeamImage={props.eventType?.isShowHeaderTeamImage || false}
        breadcrumbs={[]}
      />
    </MainDocument>
  );
}
